// extracted by mini-css-extract-plugin
module.exports = {"loop":"FormIN_loop__hzzFr","whiteColor":"FormIN_whiteColor__pdtjC"};